import { render, staticRenderFns } from "./VisionOverlay.vue?vue&type=template&id=5942eb48&scoped=true"
import script from "./VisionOverlay.vue?vue&type=script&lang=js"
export * from "./VisionOverlay.vue?vue&type=script&lang=js"
import style0 from "./VisionOverlay.vue?vue&type=style&index=0&id=5942eb48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942eb48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5942eb48')) {
      api.createRecord('5942eb48', component.options)
    } else {
      api.reload('5942eb48', component.options)
    }
    module.hot.accept("./VisionOverlay.vue?vue&type=template&id=5942eb48&scoped=true", function () {
      api.rerender('5942eb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VisionOverlay.vue"
export default component.exports